class o extends window.HTMLElement {
  constructor() {
    ;(super(),
      (this.storageKey = 'sn_recently_viewed'),
      (this.maxProducts = 12))
  }
  connectedCallback() {
    const e = this.dataset.currentProductHandle
    ;(e && (this.saveProduct(e), console.log('Saved product:', e)),
      this.loadRecentlyViewed())
  }
  saveProduct(e) {
    try {
      let t = this.getRecentlyViewed()
      ;((t = t.filter(r => r !== e)),
        t.unshift(e),
        (t = t.slice(0, this.maxProducts)),
        localStorage.setItem(this.storageKey, JSON.stringify(t)),
        console.log('Recently viewed updated:', t))
    } catch (t) {
      console.error('Failed to save recently viewed product:', t)
    }
  }
  getRecentlyViewed() {
    try {
      const e = localStorage.getItem(this.storageKey)
      if (!e) return []
      const t = JSON.parse(e)
      return t.every(s => typeof s == 'string' && isNaN(s))
        ? t
        : (console.log('Clearing old recently viewed data format'),
          localStorage.removeItem(this.storageKey),
          [])
    } catch (e) {
      return (console.error('Failed to get recently viewed products:', e), [])
    }
  }
  async loadRecentlyViewed() {
    const e = this.dataset.currentProductHandle,
      t = parseInt(this.dataset.limit) || 8
    let r = this.getRecentlyViewed()
    if (
      (console.log('Loading recently viewed:', r),
      e && (r = r.filter(s => s !== e)),
      (r = r.slice(0, t)),
      r.length === 0)
    ) {
      ;(console.log('No recently viewed products'), this.hideSection())
      return
    }
    try {
      const s = await this.fetchProducts(r)
      ;(console.log('Fetched products:', s),
        s.length > 0
          ? (this.renderProducts(s), this.classList.add('loaded'))
          : this.hideSection())
    } catch (s) {
      ;(console.error('Failed to load recently viewed products:', s),
        this.hideSection())
    }
  }
  hideSection() {
    const e = this.closest('.recently-viewed-section')
    e ? (e.style.display = 'none') : (this.style.display = 'none')
  }
  async fetchProducts(e) {
    const t = []
    for (const r of e)
      try {
        const s = await fetch(`${window.Shopify.routes.root}products/${r}.js`)
        if (s.ok) {
          const i = await s.json()
          t.push(i)
        } else console.error(`Failed to fetch product ${r}: ${s.status}`)
      } catch (s) {
        console.error(`Failed to fetch product ${r}:`, s)
      }
    return t
  }
  renderProducts(e) {
    const t = this.dataset.gap || '1.5rem',
      s = `
      <section class='featured-reviews lg:py-16 py-12'>
        <div class='featured-reviews-container'>
          <div class='md:px-8 px-4 mb-8'>
            <h2 class='text-3xl lg:text-5xl font-serif underline text-center'>
              ${this.dataset.title || 'Recently Viewed'}
            </h2>
          </div>
          <div class='reviews-container relative'>
            <div class='carousel-scroll overflow-x-auto scrollbar-hide pr-gutter-page'>
              <div class='carousel-container flex md:px-8 px-4 pt-4' style='--gap: ${t}; gap: ${t};'>
                ${e.map(i => this.renderProductCard(i)).join('')}
              </div>
            </div>
          </div>
        </div>
      </section>
    `
    this.innerHTML = s
  }
  renderProductCard(e) {
    const t = (e.price / 100).toFixed(2),
      r = e.compare_at_price ? (e.compare_at_price / 100).toFixed(2) : null,
      s = e.featured_image || e.images[0]
    return `
      <div class='product-card w-full lg:w-80 flex-shrink-0'>
        <a href='${e.url}' class='product-card-link block'>
          <div class='product-card-image aspect-square mb-4 image relative overflow-hidden'>
            ${
              s
                ? `<img
                src='${s}'
                alt='${e.title}'
                class='absolute inset-0 w-full h-full object-cover'
                loading='lazy'
              />`
                : "<div class='w-full h-full bg-light-green'></div>"
            }
          </div>
          <div class='product-card-info'>
            <h2 class='font-serif text-2xl lg:text-4xl lg:text-left text-center underline'>
              ${e.title}
            </h2>
            <div class='flex gap-2 items-center mt-2 lg:justify-start justify-center'>
              <span class='text-lg font-serif'>$${t}</span>
              ${r ? `<span class='text-sm font-serif line-through opacity-60'>$${r}</span>` : ''}
            </div>
          </div>
        </a>
      </div>
    `
  }
}
window.customElements.define('recently-viewed', o)
export { o as default }
